﻿import TagFilter from './tag-filter.js';
import { formattedNumber, getParent, getOffsetTop, getOffsetLeft } from './helpers.js';

export default class FurilloCompanyList {

    constructor(element) {
        const self = this;

        self.element = element;
        self.mapInstance = window.furillomaps.map;
        self.countryName = 'sverige';
        
        self.markerData = [];

        self.element.querySelectorAll('.partial-contact-card-page').forEach(item => {
            self.markerData.push({
                id: item.getAttribute('id'),
                title: item.getAttribute('data-title'),
                latitude: item.getAttribute('data-latitude'),
                longitude: item.getAttribute('data-longitude'),
                icon: item.getAttribute('data-marker-src'),                
                iconHighlight: item.getAttribute('data-marker-highlight-src'),                
                filtered: false,
                position: null,
                distance: null,
                marker: null
            });
        });

        self.searchMarker = null;

        self.init();
    }

    resetHighlightedMarkers() {
        const self = this;

        for (var i = 0; i < self.markerData.length; i++) {            
            self.markerData[i].marker.setIcon({ url: self.markerData[i].icon, scaledSize: new google.maps.Size(40, 40) });
            self.markerData[i].marker.setZIndex(undefined);
        }
    }

    highlightMarker(marker, icon) {
        const self = this;

        self.mapInstance.setCenter(marker.position);
        marker.setIcon({ url: icon, scaledSize: new google.maps.Size(60, 60) });
        marker.setZIndex(1000);
        new google.maps.event.trigger(marker, 'click');
    }

    registerListClickEvent(anchor) {
        const self = this;

        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const data = self.getMarkerDataById(e.target.getAttribute('data-markerid'));
            if (!data) {
                return;
            }

            self.resetHighlightedMarkers();
            self.highlightMarker(data.marker, data.iconHighlight);

            /*console.log(self.element.getBoundingClientRect());*/

            window.scroll({
                top: getOffsetTop(self.element),
                left: getOffsetLeft(self.element),
                behavior: 'smooth'
            });
        });
    }

    init() {
        const self = this;

        self.populateMapWithMarkers();

        // Ensure we have a search marker instance
        if (!self.searchMarker) {
            self.searchMarker = new window.google.maps.Marker({
                icon: {
                    url: self.element.querySelector('form.published-content-list-group-filter').getAttribute('data-marker-src'),
                    scaledSize: new google.maps.Size(40, 40)
                },
                zIndex: 1001
            });
        }
        
        // Event handler for clicking in list
        self.element.querySelectorAll('.partial-contact-card-page .card-title a').forEach(anchor => {
            self.registerListClickEvent(anchor);
        });
        
        // Event handler for submitting filter
        self.element.querySelector('form.published-content-list-group-filter').addEventListener('submit', function (e) {
            e.preventDefault();            
            self.filter();
        });
                
        const resizeObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {                
                self.setBoundsAndCenter();
            });
        });
        resizeObserver.observe(self.element.querySelector('.google-maps-placeholder'));

        self.setClientPosition();

        self.tagFilter = new TagFilter(self.element.querySelector('form.published-content-list-group-filter .tag-filters'), { listWrapper: self.element, onFiltered: function () { self.filter(); }, autoInit: false });
        self.tagFilter.init();
    }

    setClientPosition() {
        const self = this;

        if (!navigator.geolocation)
            return;

        navigator.geolocation.getCurrentPosition(function (position) {
            self.findLocation({ 'latLng': new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude) });
        });
    }

    setBoundsAndCenter() {
        const self = this;

        let bounds = new window.google.maps.LatLngBounds();
        const filteredBounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < self.markerData.length; i++) {
            const data = self.markerData[i];

            if (data && data.marker && data.marker.map !== null) {
                bounds.extend(data.position);

                if (data.filtered)
                    filteredBounds.extend(data.position);
            }
        }
        
        if (filteredBounds.length > -1) {
            bounds = filteredBounds;
        }

        if (self.searchMarker && self.searchMarker.map !== null && self.searchMarker.position) {
            bounds.extend(self.searchMarker.position);
        }
                
        self.mapInstance.setCenter(bounds.getCenter());
        self.mapInstance.fitBounds(bounds);

        // Ensure we're not to far zoomed in
        if (self.mapInstance.zoom > 13)
            self.mapInstance.setZoom(13);
    }

    cardVisible(markerDataId) {
        const element = this.element.querySelector('.partial-contact-card-page#' + markerDataId);
        if (!element)
            return false;        

        return !element.parentElement.classList.contains('d-none');
    };

    showCard(markerDataId) {
        const element = this.element.querySelector('.partial-contact-card-page#' + markerDataId)
        if (!element)
            return;

        element.parentElement.classList.remove('d-none');        
    };

    hideCard(markerDataId) {
        const element = this.element.querySelector('.partial-contact-card-page#' + markerDataId)
        if (!element)
            return;

        element.parentElement.classList.add('d-none');        
    };

    toggleGroupVisibilities() {
        this.element.querySelectorAll('.published-content-list-group').forEach(group => {

            if (group.querySelectorAll('.published-content-list > .row > .col-12:not(.d-none)').length === 0) {
                group.classList.add('d-none');
            } else {
                group.classList.remove('d-none');
            }
        });
    };

    filter() {
        const self = this;

        const address = self.element.querySelector('form.published-content-list-group-filter input[type="text"]').value;
        let tag = null;
        if (self.tagFilter.activeTags.length > 0) {
            // Only one for now
            tag = self.tagFilter.activeTags[0].replace('#', '');
        }

        for (let i = 0; i < self.markerData.length; i++) {
            const data = self.markerData[i];

            data.filtered = false;
            data.marker.setMap(self.mapInstance);

            if (tag && tag.length > 0 && !self.cardVisible(data.id)) {
                data.marker.setMap(null);                
            }
            else {
                self.showCard(data.id);
            }
        }

        self.resetHighlightedMarkers();
        self.toggleGroupVisibilities();

        if (!address || address.length === 0) {
            self.searchMarker.setMap(null);
            self.setDistanceFrom(null);
            self.setBoundsAndCenter();

            const section = self.element.querySelector('.filtered-sorted-list');
            if (section) {
                section.remove();
            }
            return;
        }
                
        self.findLocation({ 'address': address + ', ' + self.countryName }, function (location) {
            self.searchMarker.setPosition(location);
            self.searchMarker.setMap(self.mapInstance);
            self.setDistanceFrom(location);
            self.sortMarkerDataByDistance();

            // Set the first 3 as filtered in order to handle bounds
            for (let i = 0; i < self.markerData.length; i++) {
                self.markerData[i].filtered = (i < 3);
            }

            self.setBoundsAndCenter();
            self.sortList();
        });
    }

    findLocation(searchLocation, callback) {
        const self = this;

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode(searchLocation, function(results, status) {

            if (status !== window.google.maps.GeocoderStatus.OK) {
                console.warn("Google GeocoderStatus", status);
                return;
            }

            const location = results[0].geometry.location;
            
            callback(location);
        });
    }

    sortList() {
        const self = this;

        const createSection = function() {
            
            const section = document.createElement('section');
            section.classList.add('published-content-list');
            section.classList.add('list');
            section.classList.add('flex-fill');
            section.classList.add('filtered-sorted-list');

            const row = document.createElement('div');
            row.classList.add('row');

            section.append(row);

            return section;
        };

        let section = self.element.querySelector('.filtered-sorted-list');
        if (section) {
            section.remove();
        }

        let filtered = false;
        section = createSection();
        for (let i = 0; i < self.markerData.length; i++) {

            const data = self.markerData[i];

            const item = self.element.querySelector('.partial-contact-card-page#' + data.id);
            if (!item || !self.cardVisible(data.id))
                continue;

            const clone = item.cloneNode(true);
            clone.id = clone.id + '-sorted';

            const col = document.createElement('div');
            col.classList.add('col-12');
            col.classList.add('d-flex');
            col.append(clone);

            section.querySelector('.row').append(col);

            if (data.filtered)
                filtered = true;
        }

        if (filtered) {
            self.element.querySelectorAll('.published-content-list-group').forEach(group => { group.classList.add('d-none') });            
            getParent(self.element.querySelector('form.published-content-list-group-filter'), '.card').after(section);

            section.querySelectorAll('.partial-contact-card-page .card-title a').forEach(anchor => {
                self.registerListClickEvent(anchor);
            });
        }
    }

    setDistanceFrom(location) {
        const self = this;

        for (let i = 0; i < self.markerData.length; i++) {
            const data = self.markerData[i];
            
            if (location && data.position != null) {
                data.distance = window.google.maps.geometry.spherical.computeDistanceBetween(location, data.position);
            } else {
                data.distance = null;
            }

            let km = '';
            if (data.distance) {
                km = '~' + formattedNumber(data.distance / 1000, 0) + 'km';
            }

            self.element.querySelector('.partial-contact-card-page#' + data.id + ' .card-title .distance').textContent = km;
        }
    }

    getMarkerDataById(id) {
        const self = this;

        const list = self.markerData.filter(function (item) {
            return (item.id === id);
        });
        
        return list && list.length > 0 ? list[0] : null;
    }

    populateMapWithMarkers() {
        const self = this;

        const infoWindow = new window.google.maps.InfoWindow();
        for (let i = 0; i < self.markerData.length; i++) {

            // Fetch marker from list
            const data = self.markerData[i];

            // Convert positon to google maps latlng
            data.position = new window.google.maps.LatLng(data.latitude, data.longitude);
            
            // Create google maps marker object
            const marker = new window.google.maps.Marker({
                position: data.position,
                map: self.mapInstance,
                icon: {
                    url: data.icon,                    
                    scaledSize: new google.maps.Size(40, 40)
                },
                title: data.title
            });

            marker.addListener('click', () => {

                const div = document.createElement('div');
                div.classList.add('marker-info-window');

                const header = document.createElement('h5');
                header.innerText = data.title;

                const link = document.createElement('a');
                link.setAttribute('href', '#' + data.id);
                link.innerText = 'Visa "' + data.title + '" i lista...';

                div.append(header);
                div.append(link);

                infoWindow.setContent(div);

                infoWindow.open({
                    anchor: marker,
                    map: self.mapInstance,
                    shouldFocus: false
                });
                
                link.addEventListener('click', (e) => {
                    e.preventDefault();

                    var id = e.target.getAttribute('href').replace('#', '');

                    const anchor = self.element.querySelector('.partial-contact-card-page .card-title a[data-markerid="' + id + '"]:not(.d-none)');
                    const parent = getParent(anchor, '.partial-contact-card-page');

                    window.scroll({
                        top: getOffsetTop(parent) - 50,
                        left: getOffsetLeft(parent),
                        behavior: 'smooth'
                    });

                    parent.classList.add('selected');

                    setTimeout(function () {
                        parent.classList.remove('selected');
                    }, 2500);
                });
            });

            infoWindow.addListener('closeclick', () => {
                self.resetHighlightedMarkers();
            });

            // Store marker
            data.marker = marker;

            // Two way binding
            marker.markerData = data;
        }

        self.setBoundsAndCenter();
    }

    sortMarkerDataByDistance() {
        const self = this;

        function sortByDistance(a, b) {
            if (a.distance == null) {
                return 1;
            }

            if (b.distance == null) {
                return -1;
            }

            if (a.distance > b.distance) {
                return 1;
            }
            else if (a.distance === b.distance) {
                return 0;
            }
            else {
                return -1;
            }
        }

        self.markerData.sort(sortByDistance);
    }


}

